import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './LinkFreeStanding.css';

class LinkFreeStanding extends Component {
  static propTypes = {
    dark: PropTypes.bool,
    medium: PropTypes.bool,
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.shape({
      direction: PropTypes.oneOf(['right','left']),
      name: PropTypes.string,
      type: PropTypes.oneOf([
        '20',
        '30',
        'other'
      ])
    }),
    size: PropTypes.oneOf([
      'xs',
      's',
      'm',
      'l',
      'xl'
    ]),
    withBouncing: PropTypes.bool
  };

  static defaultProps = {
    href: '#'
  };

  renderLinkWithDirection () {
    const { size, children } = this.props;
    const { direction, name, type } = this.props.icon;

    const icon = <Icon
      icon={name}
      type={type}
      customClasses={styles[`icon${size}`]}/>;
    let margin = null;

    switch(size) {
      case('xs'):
      case('s'):
        margin = '12px';
      break;
      case('m'):
      case('l'):
        margin = '14px';
      break;
      case('xl'):
        margin = '20px';
      break;
    }

    if (direction === 'left') {
      return (
        <Fragment>
          {icon}
          <span style={{ 'marginLeft': margin }}>{children}</span>
        </Fragment>
      );
    }

    if (direction === 'right') {
      return (
        <Fragment>
          <span style={{ 'marginRight': margin }}>{children}</span>
          {icon}
        </Fragment>
      );
    }
  }

  render () {
    const {
      size,
      children,
      dark,
      medium,
      href,
      icon,
      withBouncing,
      className,
    ...rest } = this.props;
    const { direction } = icon || false;
    const cx = classnames.bind(styles);
    const linkClasses = cx(
      'link',
      size,
      direction,
      className,
      {
        dark,
        medium,
        'bouncing': withBouncing
      }
    );

    return (
      <a className={linkClasses} href={href} {...rest}>
        {direction ? this.renderLinkWithDirection() : <span>{children}</span>}
      </a>
    );
  }
}

export default LinkFreeStanding;



// WEBPACK FOOTER //
// ./src/uis/elements/Link/LinkFreeStanding/LinkFreeStanding.js